module.exports = __webpack_public_path__ + "static/media/S1.58800e00.webp";